export default __webpack_public_path__ + "static/adLandingpageBackground1-69ce71ee51b3b0a24e5740258d900a6f.png";